import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { JavapiService } from '../../services/javapi.service';
import { MetodosgenService } from '../../services/metodosgen.service';
import { firstValueFrom } from 'rxjs';
import { Metodosui } from '../../services/metodosui';
import { InspeccionareaComponent } from '../inspeccionarea/inspeccionarea.component';

@Component({
  selector: 'app-inspeccioneslist',
  templateUrl: './inspeccioneslist.component.html',
  styleUrls: ['./inspeccioneslist.component.scss'],
  standalone: false
})
export class InspeccioneslistComponent implements OnInit {

  @Input() cotizacion: any = null;
  @Input() selectionMode: boolean = false;

  inspecciones: any[] = [];
  displayedInspecciones: any[] = [];
  searchText: string = '';
  isLoading: boolean = true;
  showSearch: boolean = false;

  constructor(
    private modalCtrl: ModalController,
    private javapiService: JavapiService,
    private metodosGenService: MetodosgenService,
    private metodosui: Metodosui
  ) { }

  async ngOnInit() {
    this.loadInspecciones();
  }

  close() {
    this.modalCtrl.dismiss();
  }

  async loadInspecciones(silent: boolean = false) {
    if (!silent) this.isLoading = true;
    try {
      const payload = this.metodosGenService.setModeloGeneral(
        'genModel', 'inspecciones', '', '', '', '', '', '', '', '', '', '', '', '', '', '', ''
      );

      const resp: any = await firstValueFrom(this.javapiService.getCommonModel(payload));

      this.inspecciones = (resp || []).map((item: any) => ({
        id: Number(item.dt1) || 0,
        cliente: item.dt2 ?? 'Sin Cliente',
        direccion: item.dt3 ?? 'Sin Dirección',
        descripcion: item.dt4 ?? '',
        solicitante: item.dt5 ?? '',
        estado: item.dt6 ?? 'En Proceso',
        fecha_creacion: item.dt7 ?? '',
        cliente_id: Number(item.dt8) || undefined,
        direccion_id: Number(item.dt9) || undefined,
        solicitante_id: Number(item.dt10) || undefined,
        incluye_material: item.dt13 ?? 'N'
      }));

      // Si estamos vinculando una cotización con cliente específico, priorizar las del mismo cliente
      if (this.selectionMode && this.cotizacion?.cliente) {
        const clientName = this.cotizacion.cliente.trim().toLowerCase();
        this.inspecciones.sort((a, b) => {
          const aMatch = a.cliente.toLowerCase().includes(clientName);
          const bMatch = b.cliente.toLowerCase().includes(clientName);
          if (aMatch && !bMatch) return -1;
          if (!aMatch && bMatch) return 1;
          return b.id - a.id;
        });
      }

      this.applyFilters();
    } catch (e) {
      console.error('Error loading inspecciones:', e);
    } finally {
      this.isLoading = false;
    }
  }

  applyFilters() {
    if (!this.searchText.trim()) {
      this.displayedInspecciones = [...this.inspecciones];
    } else {
      const q = this.searchText.toLowerCase();
      this.displayedInspecciones = this.inspecciones.filter(i =>
        String(i.id).includes(q) ||
        i.cliente.toLowerCase().includes(q) ||
        i.direccion.toLowerCase().includes(q) ||
        i.descripcion.toLowerCase().includes(q)
      );
    }
  }

  search(event: any) {
    this.searchText = event.detail?.value || '';
    this.applyFilters();
  }

  toggleSearch() {
    this.showSearch = !this.showSearch;
    if (!this.showSearch) {
      this.searchText = '';
      this.applyFilters();
    }
  }

  async selectInspeccion(inspeccion: any) {
    if (this.selectionMode) {
      this.confirmLink(inspeccion);
    } else {
      const modal = await this.modalCtrl.create({
        component: InspeccionareaComponent,
        componentProps: { inspeccion }
      });
      await modal.present();
    }
  }

  async confirmLink(inspeccion: any) {
    const ok = await this.metodosui.showConfirmation(
      'Vincular Inspección',
      `¿Deseas vincular esta cotización a la Solicitud #${inspeccion.id} de ${inspeccion.cliente}?`,
      'Vincular'
    );
    if (ok) {
      this.modalCtrl.dismiss({ selectedInspeccion: inspeccion });
    }
  }

  getEstadoColor(estado: string): any {
    const e = (estado || '').toLowerCase();
    if (e === 'aprobada' || e === 'completada' || e === 'finalizado') {
      return { background: 'rgba(39, 174, 96, 0.12)', color: '#27ae60' };
    }
    if (e === 'en proceso' || e === 'ejecucion') {
      return { background: 'rgba(52, 152, 219, 0.12)', color: '#2980b9' };
    }
    if (e === 'pendiente' || e === 'cotizada') {
      return { background: 'rgba(243, 156, 18, 0.12)', color: '#f39c12' };
    }
    if (e === 'cancelada' || e === 'rechazada') {
      return { background: 'rgba(231, 76, 60, 0.12)', color: '#e74c3c' };
    }
    return { background: 'rgba(149, 165, 166, 0.12)', color: '#7f8c8d' };
  }
}
